import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";
import { FacilityDecorator } from "lib/decorators/index";

export default new (class FacilitiesRepository extends BaseRepository {
  findAll() {
    const bucket = this.getBucket("facilities.index");
    const request$ = this.api
      .get(`/facilities`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((facilities) => facilities.map((facility) => new FacilityDecorator(facility)));
    return this.mergeRequestWithCurrentBucketState(bucket, request$);
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/FacilitiesRepository.js